import { useDispatch, useSelector } from 'react-redux';
import useSaveShortcut from '../../../hooks/useSaveShortcut';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PosPrint, SalesTaxablePrint } from '../../../library/InvoicePrint';
import { demoPos, demoRegular } from '../../../utils/Data/StaticData';
import { showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { fetchInvoiceSettings } from '../../../redux/reducers/InvoiceSettings';
import { uploadToServer } from '../../../library/upload';
import { useCreateInvoiceSettingsMutation, useListInvoiceSettingsQuery } from '../../../redux/apis/invoiceSettingsApi.api';
import { IfscFetch } from '../../../library/IfscFetch';
import { capitalizeFirstLetters, handleFreeze, deepEqual } from '../../../utils/common';
import printJS from 'print-js';
import { compositionData, pos, regularData, regularDataForUnreg } from '../data';
import { getBase64 } from '../../../library/shared';
import { isValidIFSC, isValidSwiftCode, isValidUPI, isValidBankAccountNumber, isValidBankName, isValidBankBranchName, isValidAccountHolderName } from '../../../utils/Regex';
import API_ENDPOINTS from '../../../apiEndpoints';
import { setNavigationBlocked, setModalBlocked } from '../../../redux/reducers/controllNavigation';

export const useInvoiceSettings = ({ title = '', skip = false, parent = 'page' } = {}) => {
  console.log({ title });
  let dispatch = useDispatch();
  const [RegularSignature, setRegularSignature] = useState(null);
  const [PosSignature, setPosSignature] = useState(null);
  const location = useLocation();
  const [RegularSettings, setRegularSettings] = useState({
    companyname: 0,
    companycin: 0,
    invoicenumber: 0,
    companyaddress: 0,
    companylogo: 0,
    invoicedate: 0,
    companycontactnumber: 0,
    companyemail: 0,
    paymentmode: 0,
    companygstin: 0,
    companywebsite: 0,
    creditperiod: 0,
    companypan: 0,
    companybankdetails: 0,
    paymentduedate: 0,
    customerlegalname: 0,
    customergstin: 0,
    lutbonddetails: 0,
    customerdisplayname: 0,
    placeofsupply: 0,
    dispatchdetails: 0,
    customerbillingaddress: 0,
    customername: 0,
    customercontactperson: 0,
    customercontactnumber: 0,
    ewaybilldetails: 0,
    customershippingaddress: 0,
    customerordernoanddate: 0,
    einvoicedetails: 0,
    itemwisediscount: 0,
    hsnsacode: 0,
    showroundoff: 0,
    hsnsasummarytable: 0,
    invoicedescription: 0,
    termsandconditionsflag: 0,
    declarationatfooterflag: 0,
    declarationatfooter: '',
    termsandcondition: '',
    signaturetext: '',
    invoiceheading: '',
    bosinvoiceheading: '',
    regularinvoicesignaturefilename: '',
    defaultsetting: 1,
    upi_id: '',
    bankdetails: '',
    bank_name: '',
    branch: '',
    ac_name: '',
    ac_no: '',
    ifsc: '',
    swift_code: '',
    acknowledgement: '',
    acknowledgementflag: 0,
    errorStatus: {
      upi_id: false,
      ifsc: false,
      swift_code: false,
      ac_name: false,
      ac_no: false,
      bank_name: false,
      branch: false,
    },
    errorFields: {
      upi_id: '',
      ifsc: '',
      swift_code: '',
      ac_name: '',
      ac_no: '',
      bank_name: '',
      branch: '',
    },
  });

  // IFSC validation and auto-fill function
  const fetchIFSCData = async (ifscCode) => {
    if (ifscCode && ifscCode.length === 11) {
      setIfscLoading(true);
      try {
        const res = await IfscFetch(ifscCode);
        if (res.Status === 'success' && res.data) {
          // Auto-fill bank details
          setRegularSettings((prev) => ({
            ...prev,
            bank_name: res.data.bankName || prev.bank_name,
            branch: res.data.branchName || prev.branch,
            swift_code: res.data.swift || prev.swift_code,
          }));
        }
      } catch (error) {
        console.error('IFSC fetch error:', error);
      } finally {
        setIfscLoading(false);
      }
    }
  };

  const [previewSalesTaxableModal, setPreviewSalesTaxableModal] = useState({
    status: false,
    type: '',
  });
  const [Loading, setLoading] = useState(true);
  const [ifscLoading, setIfscLoading] = useState(false);

  const companyDetailsData = useSelector((state) => state?.companyReducer?.companyDetails);
  const RegisterationType = companyDetailsData?.relatedcompanydetailsnew?.[0]?.registrationtype;
  const [htmlTemplete, sethtmlTemplete] = useState('<html></html>');
  const [htmlposTemplete, sethtmlposTemplete] = useState('<html></html>');
  const [cachedAssets, setcachedAssets] = useState({
    companylogo: null,
    regularSignature: {
      lastModified: null,
      base: null,
    },
    posSignature: {
      lastModified: null,
      base: null,
    },
  });
  const print = async (status, type) => {
    let html = '';
    if (previewSalesTaxableModal.type == 'regular' || type == 'regular') {
      let tempInvoiceSettings = JSON.parse(JSON.stringify(RegularSettings));
      delete tempInvoiceSettings.errorFields;
      delete tempInvoiceSettings.errorStatus;
      let demo = JSON.parse(JSON.stringify(demoRegular));
      let regularAsset = '';
      if (RegularSignature) {
        if (cachedAssets.regularSignature.lastModified === RegularSignature.lastModified) {
          regularAsset = cachedAssets.regularSignature.base;
        } else {
          regularAsset = await getBase64(RegularSignature);
          setcachedAssets((prev) => ({ ...prev, regularSignature: { ...prev.regularSignature, base: regularAsset } }));
        }
      } else {
        if (cachedAssets.regularSignature.lastModified === tempInvoiceSettings.regularinvoicesignaturefilename) {
          regularAsset = cachedAssets.regularSignature.base;
        } else if (
          !cachedAssets.regularSignature.base ||
          cachedAssets.regularSignature.lastModified !== tempInvoiceSettings.regularinvoicesignaturefilename
        ) {
          regularAsset = await getBase64(tempInvoiceSettings.regularinvoicesignaturefilename);
          setcachedAssets((prev) => ({
            ...prev,
            regularSignature: {
              ...prev.regularSignature,
              base: regularAsset,
              lastModified: tempInvoiceSettings.regularinvoicesignaturefilename,
            },
          }));
        } else if (!tempInvoiceSettings.regularinvoicesignaturefilename) {
          regularAsset = '';
        }
      }

      tempInvoiceSettings.regularinvoicesignaturefilename = regularAsset;
      demo.InvoiceSettings = tempInvoiceSettings;
      demo.companyDetails = JSON.parse(JSON.stringify(companyDetailsData));
      const companyLogoAsset =
        cachedAssets.companylogo || (await getBase64(demo.companyDetails.relatedcompanydetailsnew[0].companylogourl));
      if (cachedAssets.companylogo !== companyLogoAsset) {
        setcachedAssets((prev) => ({ ...prev, companylogo: companyLogoAsset }));
      }
      demo.companyDetails.relatedcompanydetailsnew[0].companylogourl = companyLogoAsset;
      console.log(cachedAssets, companyLogoAsset);
      html = await SalesTaxablePrint(demo);
    } else if (previewSalesTaxableModal.type == 'pos' || type == 'pos') {
      let tempInvoiceSettings = JSON.parse(JSON.stringify(PosSettings));

      let regularAsset = '';
      if (PosSignature) {
        if (cachedAssets.posSignature.lastModified === PosSignature.lastModified) {
          regularAsset = cachedAssets.posSignature.base;
        } else {
          regularAsset = await getBase64(PosSignature);
          setcachedAssets((prev) => ({ ...prev, posSignature: { ...prev.posSignature, base: regularAsset } }));
        }
      } else {
        if (cachedAssets.posSignature.lastModified === tempInvoiceSettings.regularinvoicesignaturefilename) {
          regularAsset = cachedAssets.posSignature.base;
        } else if (
          !cachedAssets.posSignature.base ||
          cachedAssets.posSignature.lastModified !== tempInvoiceSettings.regularinvoicesignaturefilename
        ) {
          regularAsset = await getBase64(tempInvoiceSettings.regularinvoicesignaturefilename);
          setcachedAssets((prev) => ({
            ...prev,
            posSignature: { ...prev.posSignature, base: regularAsset, lastModified: tempInvoiceSettings.regularinvoicesignaturefilename },
          }));
        } else if (!tempInvoiceSettings.regularinvoicesignaturefilename) {
          regularAsset = '';
        }
      }

      tempInvoiceSettings.regularinvoicesignaturefilename = regularAsset;

      delete tempInvoiceSettings.errorFields;
      delete tempInvoiceSettings.errorStatus;
      let demo = JSON.parse(JSON.stringify(demoPos));
      demo.companyDetails = JSON.parse(JSON.stringify(companyDetailsData));
      const companyLogoAsset =
        cachedAssets.companylogo || (await getBase64(demo.companyDetails.relatedcompanydetailsnew[0].companylogourl));
      if (cachedAssets.companylogo !== companyLogoAsset) {
        setcachedAssets((prev) => ({ ...prev, companylogo: companyLogoAsset }));
      }
      demo.companyDetails.relatedcompanydetailsnew[0].companylogourl = companyLogoAsset;
      demo.InvoiceSettings = tempInvoiceSettings;
      html = await PosPrint(demo);
    }

    if (status) {
      if (type == 'regular') {
        sethtmlTemplete(html);
        return html;
      } else {
        sethtmlposTemplete(html);
        return html;
      }
    } else {
      printJS({
        printable: html,
        type: 'raw-html',
        documentTitle: '',
      });
    }
  };
  const {
    data: InvoiceSettingsList,
    isLoading: InvoiceSettingsListLoading,
    isError: InvoiceSettingsListError,
    isFetching: InvoiceSettingsFetching,
    // refetch
  } = useListInvoiceSettingsQuery(
    { type: 'ALL' },
    {
      refetchOnMountOrArgChange: true,
      skip,
    }
  );
  console.log({ InvoiceSettingsList });
  const getData = async () => {
    // let apis = [
    //   API.graphql(graphqlOperation(listInvoiceSettings, { type: "ALL" })),
    // ];
    console.log({ InvoiceSettingsList });
    Promise.all(InvoiceSettingsList)
      .then((response) => {
        for (let index = 0; index < response.length; index++) {
          const element = response[index];
          if (element.typecd === 'RegularSettings') {
            setRegularSettings((prev) => {
              let temp = {};
              Object.keys(prev).map((elem) => {
                temp[elem] = element?.[elem];
              });
              return { ...temp, errorFields: prev.errorFields, errorStatus: prev.errorStatus };
            });
          }
          const elementPos = response[index];
          if (elementPos.typecd === 'PosSettings') {
            setPosSettings((prev) => {
              let temp = {};
              Object.keys(prev).map((elem) => {
                temp[elem] = elementPos?.[elem];
              });
              return { ...temp, errorFields: prev.errorFields, errorStatus: prev.errorStatus };
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (!InvoiceSettingsListLoading) getData();
    return () => { };
  }, [InvoiceSettingsList, InvoiceSettingsListLoading]);

  const [PosSettings, setPosSettings] = useState({
    companyname: 0,
    companycin: 0,
    invoicenumber: 0,
    companyaddress: 0,
    companylogo: 0,
    invoicedate: 0,
    companycontactnumber: 0,
    companyemail: 0,
    paymentmode: 0,
    companygstin: 0,
    companywebsite: 0,
    companypan: 0,
    customername: 0,
    customercontactnumber: 0,
    itemwisediscount: 0,
    hsnsacode: 0,
    showroundoff: 0,
    signaturetext: '',
    invoiceheading: '',
    bosinvoiceheading: '',
    regularinvoicesignaturefilename: '',
    defaultsetting: 1,
    upi_id: '',
    bankdetails: '',
    bank_name: '',
    branch: '',
    ac_name: '',
    ac_no: '',
    ifsc: '',
    swift_code: '',
    acknowledgement: '',
    acknowledgementflag: 0,
    errorStatus: {
      upi_id: false,
    },
    errorFields: {
      upi_id: '',
    },
  });
  console.log({
    RegularSettings,
    InvoiceSettingsList,
    RegularSignature,
    InvoiceSettingsListLoading,
  });
  useEffect(() => {
    if (!InvoiceSettingsListLoading) {
      print(true, 'regular');
    }
    return () => { };
  }, [RegularSettings, InvoiceSettingsList, RegularSignature, InvoiceSettingsListLoading]);

  useEffect(() => {
    if (!InvoiceSettingsListLoading) print(true, 'pos');
    return () => { };
  }, [PosSettings, InvoiceSettingsList, PosSignature, InvoiceSettingsListLoading]);

  let regular = [...regularData];
  if (RegisterationType == 1) {
    regular = [...regularDataForUnreg];
  } else if (RegisterationType == 3) {
    regular = [...compositionData];
  }

  const handleCheckBox = useCallback((e, key) => {
    setRegularSettings((prev) => ({
      ...prev,
      [key]: e.target.checked ? 1 : 0,
    }));
  }, []);

  const handleInput = useCallback(
    (e, key) => {
      key = key || e.target.name;
      let value = e?.target?.value;

      if (key === 'invoiceheading' || key === 'signaturetext' || key === 'bosinvoiceheading') {
        value = capitalizeFirstLetters(value);
        if (value.length >= 50) return;
      }

      if (key === 'upi_id') {
        value = value.replace(/\s+/g, '');
      }

      // Sanitize IFSC code - only allow uppercase letters and numbers, remove spaces
      if (key === 'ifsc') {
        value = value.replace(/[^A-Z0-9]/g, ''); // Remove any character that's not A-Z or 0-9
        value = value.toUpperCase(); // Ensure uppercase
      }

      // Live sanitize for Bank Name
      if (key === 'bank_name') {
        value = value.replace(/[^A-Za-z. ,]/g, '');
        value = value.replace(/^\s+/, ''); // Remove leading spaces only
      }

      // Live sanitize for Branch
      if (key === 'branch') {
        value = value.replace(/[^A-Za-z0-9\-\/ ,.]/g, '');
        value = value.replace(/^\s+/, ''); // Remove leading spaces only
      }

      // Enforce max 100 chars for bank name and branch
      if (key === 'bank_name' || key === 'branch') {
        if (value && value.length > 100) value = value.slice(0, 100);
      }

      // Sanitize Account Name to allow letters, numbers, spaces, and special chars (-, &, .)
      if (key === 'ac_name') {
        value = value.replace(/[^A-Za-z0-9\-&. ]/g, '');
        value = value.replace(/^\s+/, ''); // Remove leading spaces only
        // Apply Pascal case - capitalize first letter of each word
        if (value) {
          value = capitalizeFirstLetters(value);
        }
        // Enforce max 150 chars for account name
        if (value && value.length > 150) value = value.slice(0, 150);
      }

      // Sanitize Account Number to allow only digits (prevent e, E, +, -, .)
      if (key === 'ac_no') {
        value = value.replace(/[^0-9]/g, '');
      }

      setRegularSettings((prev) => {
        const newState = { ...prev, [key]: value };

        // If field has error, validate while typing
        if (prev.errorStatus?.[key]) {
          if (key === 'upi_id') {
            if (!value || value.length === 0) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, [key]: '' },
                errorStatus: { ...prev.errorStatus, [key]: false },
              };
            }
            if (isValidUPI(value)) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, [key]: '' },
                errorStatus: { ...prev.errorStatus, [key]: false },
              };
            } else {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, [key]: 'Invalid UPI !' },
                errorStatus: { ...prev.errorStatus, [key]: true },
              };
            }
          }

          // Validate IFSC code
          if (key === 'ifsc') {
            if (!value || value.length === 0) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, ifsc: '' },
                errorStatus: { ...prev.errorStatus, ifsc: false },
              };
            }
            if (isValidIFSC(value)) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, ifsc: '' },
                errorStatus: { ...prev.errorStatus, ifsc: false },
              };
            } else {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, ifsc: 'Invalid IFSC code' },
                errorStatus: { ...prev.errorStatus, ifsc: true },
              };
            }
          }

          // Validate SWIFT code
          if (key === 'swift_code') {
            if (!value || value.length === 0) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, swift_code: '' },
                errorStatus: { ...prev.errorStatus, swift_code: false },
              };
            }
            if (isValidSwiftCode(value)) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, swift_code: '' },
                errorStatus: { ...prev.errorStatus, swift_code: false },
              };
            } else {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, swift_code: 'Invalid SWIFT code' },
                errorStatus: { ...prev.errorStatus, swift_code: true },
              };
            }
          }

          // Validate Bank Name
          if (key === 'bank_name') {
            if (!value || value.length === 0) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, bank_name: '' },
                errorStatus: { ...prev.errorStatus, bank_name: false },
              };
            }
            if (value.length > 100) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, bank_name: 'Must be at most 100 characters' },
                errorStatus: { ...prev.errorStatus, bank_name: true },
              };
            }
            if (!isValidBankName(value)) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, bank_name: 'Only letters, spaces and dot allowed' },
                errorStatus: { ...prev.errorStatus, bank_name: true },
              };
            }
            if (value.length >= 3) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, bank_name: '' },
                errorStatus: { ...prev.errorStatus, bank_name: false },
              };
            } else {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, bank_name: 'Must be at least 3 characters' },
                errorStatus: { ...prev.errorStatus, bank_name: true },
              };
            }
          }

          // Validate Branch
          if (key === 'branch') {
            if (!value || value.length === 0) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, branch: '' },
                errorStatus: { ...prev.errorStatus, branch: false },
              };
            }
            if (value.length > 100) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, branch: 'Must be at most 100 characters' },
                errorStatus: { ...prev.errorStatus, branch: true },
              };
            }
            if (!isValidBankBranchName(value)) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, branch: 'Invalid branch name' },
                errorStatus: { ...prev.errorStatus, branch: true },
              };
            }
            if (value.length >= 3) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, branch: '' },
                errorStatus: { ...prev.errorStatus, branch: false },
              };
            } else {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, branch: 'Must be at least 3 characters' },
                errorStatus: { ...prev.errorStatus, branch: true },
              };
            }
          }

          // Validate Account Name
          if (key === 'ac_name') {
            if (!value || value.length === 0) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, ac_name: '' },
                errorStatus: { ...prev.errorStatus, ac_name: false },
              };
            }
            if (value.length > 150) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, ac_name: 'Must be at most 150 characters' },
                errorStatus: { ...prev.errorStatus, ac_name: true },
              };
            }
            if (!isValidAccountHolderName(value)) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, ac_name: 'Must contain at least 1 letter and be at least 3 characters' },
                errorStatus: { ...prev.errorStatus, ac_name: true },
              };
            }
            if (value.length >= 3) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, ac_name: '' },
                errorStatus: { ...prev.errorStatus, ac_name: false },
              };
            } else {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, ac_name: 'Must be at least 3 characters' },
                errorStatus: { ...prev.errorStatus, ac_name: true },
              };
            }
          }

          // Validate Account Number
          if (key === 'ac_no') {
            if (!value || value.length === 0) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, ac_no: '' },
                errorStatus: { ...prev.errorStatus, ac_no: false },
              };
            }
            if (isValidBankAccountNumber(value)) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, ac_no: '' },
                errorStatus: { ...prev.errorStatus, ac_no: false },
              };
            } else {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, ac_no: 'Account number must be 9-16 digits' },
                errorStatus: { ...prev.errorStatus, ac_no: true },
              };
            }
          }
        }

        return newState;
      });

      // Auto-fetch IFSC data when IFSC field is updated and valid
      if (key === 'ifsc' && value.length === 11 && isValidIFSC(value)) {
        fetchIFSCData(value);
      }
    },
    [setRegularSettings, fetchIFSCData]
  );

  const handleInputBlur = useCallback(
    (e, key) => {
      key = key || e.target.name;
      let value = e?.target?.value?.trim() || ''; // Trim value on blur

      if (key === 'upi_id') {
        if (!value || value.length === 0) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: '',
            errorFields: { ...prev.errorFields, [key]: '' },
            errorStatus: { ...prev.errorStatus, [key]: false },
          }));
        }
        if (isValidUPI(value)) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, [key]: '' },
            errorStatus: { ...prev.errorStatus, [key]: false },
          }));
        } else {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, [key]: 'Invalid UPI !' },
            errorStatus: { ...prev.errorStatus, [key]: true },
          }));
        }
      }

      // Validate IFSC code
      if (key === 'ifsc') {
        if (!value || value.length === 0) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: '',
            errorFields: { ...prev.errorFields, ifsc: '' },
            errorStatus: { ...prev.errorStatus, ifsc: false },
          }));
        }
        if (isValidIFSC(value)) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, ifsc: '' },
            errorStatus: { ...prev.errorStatus, ifsc: false },
          }));
        } else {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, ifsc: 'Invalid IFSC code' },
            errorStatus: { ...prev.errorStatus, ifsc: true },
          }));
        }
      }

      // Validate SWIFT code
      if (key === 'swift_code') {
        if (!value || value.length === 0) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: '',
            errorFields: { ...prev.errorFields, swift_code: '' },
            errorStatus: { ...prev.errorStatus, swift_code: false },
          }));
        }
        if (isValidSwiftCode(value)) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, swift_code: '' },
            errorStatus: { ...prev.errorStatus, swift_code: false },
          }));
        } else {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, swift_code: 'Invalid SWIFT code' },
            errorStatus: { ...prev.errorStatus, swift_code: true },
          }));
        }
      }

      // Validate Bank Name
      if (key === 'bank_name') {
        if (!value || value.length === 0) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: '',
            errorFields: { ...prev.errorFields, bank_name: '' },
            errorStatus: { ...prev.errorStatus, bank_name: false },
          }));
        }
        // Replace multiple spaces with single space
        value = value.replace(/\s+/g, ' ');
        if (value.length > 100) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, bank_name: 'Must be at most 100 characters' },
            errorStatus: { ...prev.errorStatus, bank_name: true },
          }));
        }
        if (!isValidBankName(value)) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, bank_name: 'Only letters, spaces and dot allowed' },
            errorStatus: { ...prev.errorStatus, bank_name: true },
          }));
        }
        if (value.length >= 3) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, bank_name: '' },
            errorStatus: { ...prev.errorStatus, bank_name: false },
          }));
        } else {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, bank_name: 'Must be at least 3 characters' },
            errorStatus: { ...prev.errorStatus, bank_name: true },
          }));
        }
      }

      // Validate Branch
      if (key === 'branch') {
        if (!value || value.length === 0) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: '',
            errorFields: { ...prev.errorFields, branch: '' },
            errorStatus: { ...prev.errorStatus, branch: false },
          }));
        }
        // Replace multiple spaces with single space
        value = value.replace(/\s+/g, ' ');
        if (value.length > 100) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, branch: 'Must be at most 100 characters' },
            errorStatus: { ...prev.errorStatus, branch: true },
          }));
        }
        if (!isValidBankBranchName(value)) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, branch: 'Invalid branch name' },
            errorStatus: { ...prev.errorStatus, branch: true },
          }));
        }
        if (value.length >= 3) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, branch: '' },
            errorStatus: { ...prev.errorStatus, branch: false },
          }));
        } else {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, branch: 'Must be at least 3 characters' },
            errorStatus: { ...prev.errorStatus, branch: true },
          }));
        }
      }

      // Validate Account Name
      if (key === 'ac_name') {
        if (!value || value.length === 0) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: '',
            errorFields: { ...prev.errorFields, ac_name: '' },
            errorStatus: { ...prev.errorStatus, ac_name: false },
          }));
        }
        // Replace multiple spaces with single space
        value = value.replace(/\s+/g, ' ');
        // Apply Pascal case - capitalize first letter of each word
        value = capitalizeFirstLetters(value);
        if (value.length > 150) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, ac_name: 'Must be at most 150 characters' },
            errorStatus: { ...prev.errorStatus, ac_name: true },
          }));
        }
        if (!isValidAccountHolderName(value)) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, ac_name: 'Must contain at least 1 letter and be at least 3 characters' },
            errorStatus: { ...prev.errorStatus, ac_name: true },
          }));
        }
        if (value.length >= 3) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, ac_name: '' },
            errorStatus: { ...prev.errorStatus, ac_name: false },
          }));
        } else {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, ac_name: 'Must be at least 3 characters' },
            errorStatus: { ...prev.errorStatus, ac_name: true },
          }));
        }
      }

      // Validate Account Number
      if (key === 'ac_no') {
        if (!value || value.length === 0) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: '',
            errorFields: { ...prev.errorFields, ac_no: '' },
            errorStatus: { ...prev.errorStatus, ac_no: false },
          }));
        }
        if (isValidBankAccountNumber(value)) {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, ac_no: '' },
            errorStatus: { ...prev.errorStatus, ac_no: false },
          }));
        } else {
          return setRegularSettings((prev) => ({
            ...prev,
            [key]: value,
            errorFields: { ...prev.errorFields, ac_no: 'Account number must be 9-16 digits' },
            errorStatus: { ...prev.errorStatus, ac_no: true },
          }));
        }
      }
    },
    [setRegularSettings]
  );

  const formatOnBlur = useCallback(
    (e, key) => {
      key = key || e.target.name;
      let value = e?.target?.value;
      value = value
        .split('\n') // Split by new line
        .map((line) => line.trim()) // Trim each line
        .filter((line) => line !== '') // Remove empty lines
        .join('\n');
      setRegularSettings((prev) => ({ ...prev, [key]: value }));
    },
    [setRegularSettings]
  );
  const handleInput2 = useCallback(
    (e, key) => {
      key = key || e.target.name;
      let value = e?.target?.value;
      if (key === 'invoiceheading' || key === 'signaturetext' || key === 'bosinvoiceheading') {
        value = capitalizeFirstLetters(value);
        if (value.length >= 50) return;
      }
      if (key === 'upi_id') {
        value = value.replace(/\s+/g, '');
      }

      setPosSettings((prev) => {
        const newState = { ...prev, [key]: value };

        // If field has error, validate while typing
        if (prev.errorStatus?.[key]) {
          if (key === 'upi_id') {
            if (!value || value.length === 0) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, [key]: '' },
                errorStatus: { ...prev.errorStatus, [key]: false },
              };
            }
            if (isValidUPI(value)) {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, [key]: '' },
                errorStatus: { ...prev.errorStatus, [key]: false },
              };
            } else {
              return {
                ...newState,
                errorFields: { ...prev.errorFields, [key]: 'Invalid UPI !' },
                errorStatus: { ...prev.errorStatus, [key]: true },
              };
            }
          }
        }

        return newState;
      });
    },
    [setPosSettings]
  );

  const handleInput2Blur = useCallback(
    (e, key) => {
      key = key || e.target.name;
      let value = e?.target?.value;

      if (key === 'upi_id') {
        if (!value || value.length === 0) {
          return setPosSettings((prev) => ({
            ...prev,
            errorFields: { ...prev.errorFields, [key]: '' },
            errorStatus: { ...prev.errorStatus, [key]: false },
          }));
        }
        if (isValidUPI(value)) {
          return setPosSettings((prev) => ({
            ...prev,
            errorFields: { ...prev.errorFields, [key]: '' },
            errorStatus: { ...prev.errorStatus, [key]: false },
          }));
        } else {
          return setPosSettings((prev) => ({
            ...prev,
            errorFields: { ...prev.errorFields, [key]: 'Invalid UPI !' },
            errorStatus: { ...prev.errorStatus, [key]: true },
          }));
        }
      }
    },
    [setPosSettings]
  );
  const handlePOSCheckBox = useCallback(
    (e, key) => {
      setPosSettings((prev) => ({ ...prev, [key]: e.target.checked ? 1 : 0 }));
    },
    [setPosSettings]
  );

  const navigate = useNavigate();

  const handleCancel = () => {
    if (location?.state?.title === 'sales') {
      navigate('/addnewinvoicetax', { state: { updated: true } });
    } else if (location?.state?.title === 'newpos') {
      navigate('/newpos', { state: { updated: true } });
    } else {
      navigate('/');
    }
  };

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  const [createInvoiceSettingsApi] = useCreateInvoiceSettingsMutation();

  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/InvoiceSettings/`;

  const saveChanges = async ({ regular, pos } = {}) => {
    if (skip) return;
    const regularSettings = regular || RegularSettings;
    const posSettings = pos || PosSettings;
    try {
      if (Loading) {
        return console.log('Loading');
      }
      if (Freeze === 1) {
        return handleFreeze();
      }
      let tempRegularSettings = JSON.parse(JSON.stringify(regularSettings));
      let tempPosSettings = JSON.parse(JSON.stringify(posSettings));
      delete tempRegularSettings.errorFields;
      delete tempRegularSettings.errorStatus;
      delete tempPosSettings.errorFields;
      delete tempPosSettings.errorStatus;
      delete tempPosSettings.companyid;
      tempRegularSettings.declarationatfooterflag = Number(tempRegularSettings.declarationatfooterflag);
      setLoading(true);
      // validation
      if (tempRegularSettings.upi_id.length && !isValidUPI(tempRegularSettings.upi_id)) {
        setRegularSettings((prev) => ({
          ...prev,
          errorFields: { ...prev['errorFields'], upi_id: 'Invalid UPI' },
          errorStatus: { ...prev.errorStatus, upi_id: true },
        }));
        return;
      } else {
        setRegularSettings((prev) => ({
          ...prev,
          errorFields: { ...prev['errorFields'], upi_id: '' },
          errorStatus: { ...prev.errorStatus, upi_id: false },
        }));
      }

      if (tempPosSettings.upi_id.length && !isValidUPI(tempPosSettings.upi_id)) {
        setPosSettings((prev) => ({
          ...prev,
          errorFields: { ...prev['errorFields'], upi_id: 'Invalid UPI' },
          errorStatus: { ...prev.errorStatus, upi_id: true },
        }));
        return;
      } else {
        setPosSettings((prev) => ({
          ...prev,
          errorFields: { ...prev['errorFields'], upi_id: '' },
          errorStatus: { ...prev.errorStatus, upi_id: false },
        }));
      }

      // Validate Regular Settings bank details
      const regularIfscTrimmed = tempRegularSettings.ifsc?.trim();
      const regularSwiftTrimmed = tempRegularSettings.swift_code?.trim();
      const regularAcNameTrimmed = tempRegularSettings.ac_name?.trim();
      const regularAcNoTrimmed = tempRegularSettings.ac_no?.trim();
      const regularBankNameTrimmed = tempRegularSettings.bank_name?.trim();
      const regularBranchTrimmed = tempRegularSettings.branch?.trim();

      if (regularIfscTrimmed && regularIfscTrimmed.length > 0 && !isValidIFSC(regularIfscTrimmed)) {
        showWarningSnackbar('Invalid IFSC code in Regular Settings');
        return;
      }

      if (regularSwiftTrimmed && regularSwiftTrimmed.length > 0 && !isValidSwiftCode(regularSwiftTrimmed)) {
        showWarningSnackbar('Invalid SWIFT code in Regular Settings');
        return;
      }

      if (regularBankNameTrimmed && regularBankNameTrimmed.length > 0) {
        if (regularBankNameTrimmed.length > 100) {
          showWarningSnackbar('Bank name must be at most 100 characters in Regular Settings');
          return;
        }
        if (!isValidBankName(regularBankNameTrimmed)) {
          showWarningSnackbar('Bank name must contain only letters, spaces and dot in Regular Settings');
          return;
        }
        if (regularBankNameTrimmed.length < 3) {
          showWarningSnackbar('Bank name must be at least 3 characters in Regular Settings');
          return;
        }
      }

      if (regularBranchTrimmed && regularBranchTrimmed.length > 0) {
        if (regularBranchTrimmed.length > 100) {
          showWarningSnackbar('Branch name must be at most 100 characters in Regular Settings');
          return;
        }
        if (!isValidBankBranchName(regularBranchTrimmed)) {
          showWarningSnackbar('Invalid branch name');
          return;
        }
        if (regularBranchTrimmed.length < 3) {
          showWarningSnackbar('Branch name must be at least 3 characters in Regular Settings');
          return;
        }
      }

      if (regularAcNameTrimmed && regularAcNameTrimmed.length > 0) {
        if (regularAcNameTrimmed.length > 150) {
          showWarningSnackbar('Account name must be at most 150 characters in Regular Settings');
          return;
        }
        if (!isValidAccountHolderName(regularAcNameTrimmed)) {
          showWarningSnackbar('Account name must contain at least 1 letter and be at least 3 characters in Regular Settings');
          return;
        }
        if (regularAcNameTrimmed.length < 3) {
          showWarningSnackbar('Account name must be at least 3 characters in Regular Settings');
          return;
        }
      }

      if (regularAcNoTrimmed && regularAcNoTrimmed.length > 0) {
        if (!isValidBankAccountNumber(regularAcNoTrimmed)) {
          showWarningSnackbar('Account number must be 9-16 digits in Regular Settings');
          return;
        }
      }

      let regularSignatureFilename = tempRegularSettings.regularinvoicesignaturefilename || '';
      if (RegularSignature) {
        let fileName = path + 'thex-' + Date.now() + '-' + RegularSignature.name.replace("'", '');
        await uploadToServer(RegularSignature, fileName);
        regularSignatureFilename = API_ENDPOINTS.REACT_APP_S3_BUCKET_URL + '/' + fileName;
      }

      let posSignatureFilename = tempPosSettings.regularinvoicesignaturefilename || '';
      if (PosSignature) {
        let fileName = path + 'thex-' + Date.now() + '-' + PosSignature.name.replace("'", '');
        await uploadToServer(PosSignature, fileName);
        posSignatureFilename = API_ENDPOINTS.REACT_APP_S3_BUCKET_URL + '/' + fileName;
      }

      let Regulardata = {
        customergstin: tempRegularSettings.customergstin,
        // enteredtimestamp: 0,
        expiredtimestamp: 0,
        typecd: 'RegularSettings',
        bankdetails: 'bank details',
        ...tempRegularSettings,
        regularinvoicesignaturefilename: regularSignatureFilename || '',
        posinvoicesignaturefilename: '',
      };
      let PosData = {
        // enteredtimestamp: 0,
        expiredtimestamp: 0,
        typecd: 'PosSettings',
        ...tempPosSettings,
        upi_id: tempPosSettings.upi_id || '',
        signaturetext: tempPosSettings.signaturetext || '',
        bankdetails: 'bank details',
        regularinvoicesignaturefilename: posSignatureFilename || '',
        //
        posinvoicesignaturefilename: '',
        declarationatfooter: '',
        declarationatfooterflag: 0,
        termsandcondition: '',
        termsandconditionsflag: 0,
        companybankdetails: 0,
        customerlegalname: 0,
        lutbonddetails: 0,
        invoicedescription: 0,
        ewaybilldetails: 0,
        creditperiod: 0,
        customergstin: 0,
        einvoicedetails: 0,
        customercontactperson: 0,
        hsnsasummarytable: 0,
        customershippingaddress: 0,
        placeofsupply: 0,
        customerdisplayname: 0,
        dispatchdetails: 0,
        customerbillingaddress: 0,
        customerordernoanddate: 0,
        paymentduedate: 0,
      };
      if (!regular && !pos) {
        Regulardata.defaultsetting = 0;
        PosData.defaultsetting = 0;
      }
      if (Regulardata?.invoiceheading === '') {
        Regulardata.invoiceheading = 'Tax Invoice';
      }
      if (Regulardata?.bosinvoiceheading === '') {
        Regulardata.bosinvoiceheading = 'Bill Of Supply';
      }
      if (PosData?.invoiceheading === '') {
        PosData.invoiceheading = 'POS Tax Invoice';
      }
      if (PosData?.bosinvoiceheading === '') {
        PosData.bosinvoiceheading = 'POS Bill Of Supply';
      }
      let result = await createInvoiceSettingsApi({
        invoiceSettingsInput: [Regulardata, PosData],
      });
      if (result.data == null) {
        showWarningSnackbar('Something went wrong !');
      } else {
        showSuccessSnackbar('Settings Updated !');
      }
      let results = await dispatch(fetchInvoiceSettings());
      if (location?.state?.title === 'sales') {
        return navigate('/addnewinvoicetax', { state: { updated: true } });
      } else if (location?.state?.title === 'newpos') {
        return navigate('/newpos', { state: { updated: true } });
      }
      setLoading(false);
      return result.data;
    } catch (error) {
      showWarningSnackbar('Something went wrong !');
      setLoading(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const fileUploadInput = (file, set) => {
    let uploadedFile = file;
    try {
      if (uploadedFile) {
        if (uploadedFile?.type == 'image/jpeg' || uploadedFile?.type == 'image/jpg' || uploadedFile?.type == 'image/png') {
          if (Number(uploadedFile?.size) < 1048576) {
            set(uploadedFile);
          } else {
            showWarningSnackbar('File size should be less than 1MB');
          }
        } else {
          showWarningSnackbar('Only jpg, jpeg extensions Files are allowed');
        }
      } else {
        set(uploadedFile);
      }
    } catch (e) {
      console.log('error ::: ', e);
    } finally {
    }
  };

  const [warningModal, setwarningModal] = useState(false);

  useEffect(() => {
    const setHeight = () => {
      const previewElement = document.getElementById('regularPreview');
      const settingsElement = document.getElementById('regularSettings');
      let previewWidth = 0;
      if (previewElement && settingsElement) {
        // Get the height of the preview element
        const previewHeight = previewElement.offsetHeight;
        previewWidth = settingsElement.offsetWidth;
        // Apply the preview height to the settings element
        settingsElement.style.minHeight = previewHeight ? `${previewHeight}px` : '0px';
      } else {
        previewWidth = settingsElement?.offsetWidth;
      }
      const pospreviewElement = document.getElementById('posPreview');
      const possettingsElement = document.getElementById('posSettings');

      if (pospreviewElement && possettingsElement) {
        // Get the height of the preview element
        // const pospreviewHeight = pospreviewElement.offsetHeight;

        // Apply the preview height to the settings element
        possettingsElement.style.width = `${previewWidth}px`;
        // possettingsElement.style.height = `${pospreviewHeight}px`;
      }
    };

    if (window.innerWidth > 550) {
      setHeight();
      window.addEventListener('resize', setHeight);
    }

    // Cleanup the event listener
    return () => {
      window.removeEventListener('resize', setHeight);
    };
  }, [htmlTemplete, htmlposTemplete]);
  useSaveShortcut(async () => {
    if (!title) {
      saveChanges();
    }
  });

  console.log({ PosSettings, RegularSettings });

  return {
    saveChanges,
    print,
    warningModal,
    previewSalesTaxableModal,
    htmlposTemplete,
    htmlTemplete,
    regular,
    pos,
    Loading,
    ifscLoading,
    RegularSettings,
    PosSettings,
    RegularSignature,
    RegisterationType,
    InvoiceSettingsListLoading,
    InvoiceSettingsFetching,
    handleInput,
    handleInput2,
    handleInputBlur,
    handleInput2Blur,
    handleCheckBox,
    handlePOSCheckBox,
    handleCancel,
    fileUploadInput,
    setPreviewSalesTaxableModal,
    setRegularSignature,
    setRegularSettings,
    setPosSignature,
    setPosSettings,
    setwarningModal,
    formatOnBlur,
  };
};
